//
//
//
//
//
//

import { isEmpty } from 'lodash';

export default {
  name: 'ApplyList',
  props: {
    more: { type: Boolean, default: false },
    details: { type: Boolean, default: false },
    pageSize: { type: Number, default: 10 },
  },
  data() {
    return {
      dataList: null,
      status: null,
      currentPage: 1,
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.dataList);
    },
    filterData() {
      if (this.status !== null) {
        return this.dataList.filter(item => {
          return item.status === this.status;
        });
      }
      return this.dataList;
    },
  },
  methods: {
    getApplicant() {
      const payload = {
        current: this.currentPage,
        size: this.pageSize,
        status: this.status,
      };
      this.$api('userGetApplicantList', payload).then(data => {
        this.dataList = data.records;
      });
    },
  },
  mounted() {
    this.getApplicant();
  },
};
